import { GridEventListener } from '@mui/x-data-grid-pro';

export const handleRowEditStop: GridEventListener<'cellEditStop'> = (_params, event) => {
    event.defaultMuiPrevented = true;
};
